import Swal from 'sweetalert2'
import { mountVueComponent, unmountVueComponent } from './vue-core'
import type { Component } from 'vue'
import { useAuthStore } from '../stores/auth';
import { pinia } from './pinia';

export const showVuePopup = async (
	component: Component,
	props: Record<string, any> = {},
	options: Partial<any> = {}
) => {
	// ระบุ pinia ตรง ๆ — ฟังก์ชันนี้ถูกเรียกนอก component context
	const auth = useAuthStore(pinia)
	auth.hydrate()

	const wrapperId = 'vue-popup-' + Math.random().toString(36).substring(2, 8)

	const close = async () => Swal.close()

	const { customClass: optionsCustomClass, ...restOptions } = options;

	await Swal.fire({
		title: '',
		html: `<div id="${wrapperId}"></div>`,
		showConfirmButton: false,
		showCloseButton: true,
		closeButtonHtml: '<img src="https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/btn-close.webp" alt="" class="size-8"/>',
		allowOutsideClick: false,
		customClass: {
			closeButton: 'absolute top-0 right-0 size-8! -translate-y-1/3 translate-x-1/3 bg-gray-100 hover:bg-gray-300 shadow rounded-full justify-center! items-center!',
			popup: 'bg-[url(https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/bg-profile-m.webp)] bg-size-[100%_100%] bg-center bg-transparent',
			htmlContainer: 'min-h-[34rem]',
			...(optionsCustomClass || {}),
		},
		didOpen: () => {
			mountVueComponent(component, { ...props, close }, wrapperId)
			options.didOpen?.()
		},
		willClose: () => {
			unmountVueComponent(wrapperId)
			options.willClose?.()
		},
		...restOptions,
	});
}
